import React from 'react'
import { Table as AntTable, TableProps } from 'antd'
import styled from 'styled-components'
import { useTheme } from 'next-themes'

const TableWrapper: any = styled(AntTable)`
  .ant-table {
    background: transparent;
    font-size: 16px;
  }
  .ant-table-thead > tr > th {
    background: transparent;
    color: #969999;
    font-size: 14px;
    font-weight: 700;
  }
  .ant-table-tbody > tr.ant-table-row:hover > td,
  .ant-table-tbody > tr > td.ant-table-cell-row-hover {
    background: transparent;
  }

  .ant-table-tbody > tr > td {
    border: none;
  }

  ${({ themeplate }: { themeplate: 'dark' | 'light' }) => `.ant-table-thead > tr > th {
    border-bottom: 1px solid
       ${themeplate === 'light' ? '#0D0F071A' : '#FDFFFA1A'};
    border-top: 1px solid ${themeplate === 'light' ? '#0D0F071A;' : '#FDFFFA1A;'};

    ::before {
      display: none;
    }
  }`}
`

export interface CustomTableProps<T> extends TableProps<T> {
  isMobileView?: boolean
}

function Table<T extends object = any>(props: CustomTableProps<T>) {
  const { theme } = useTheme()
  return <TableWrapper themeplate={theme} scroll={{ x: 'max-content' }} {...props} />
}

export default Table
